import React, { useState } from 'react'
import Graph from './Graph' // Adjust the import path as necessary
import { useEffect } from 'preact/hooks'
import endpoints from '../endpoints.json'
import { useLocation, useNavigate } from 'react-router-dom'
import './dashboardpage.css'

const DashboardPage = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [userId, setUserId] = useState(state?.userId)
  const [displayG, setDisplayG] = useState(false)
  // Add the user ID state
  const [graphs, setGraphs] = useState([
    { graphData: {}, graphConf: {} },
    { graphData: {}, graphConf: {} }
    // Add more initial graphs if needed
  ])

  const updateGraphData = (index, newGraphData) => {
    const newGraphs = [...graphs]
    newGraphs[index].graphData = newGraphData
    setGraphs(newGraphs)
  }

  const updateGraphConf = (index, newGraphConf) => {
    const newGraphs = [...graphs]
    newGraphs[index].graphConf = newGraphConf
    setGraphs(newGraphs)
  }

  useEffect(() => {
    console.log('DashboardPage mounted')
    const fetchData = async () => {
      const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraphs`, {
        userId: userId
      })
      console.log(response)
      setGraphs(response)
      setDisplayG(true)
    }
    fetchData()
  }, [])

  const removeGraph = async (id) => {
    console.log(graphs)
    console.log('Removing graph with ID:', id)
    const newGraphs = graphs.filter((graph, index) => graph.id !== id)
    setGraphs(newGraphs)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/deletegraph`, { id })
  }

  const editGraph = async (graph) => {
    console.log(userId)
    navigate('/dashboards', { state: { graphConfig: graph.graphConf, id: graph.id, userId: userId } })
  }

  return (
    <div className="root">
      <div className="header1">
        {/* Flex item for icon and text on the left */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
          style={{ width: '100px', height: 'auto' }}
        />
        <div className="one-ux-typography--heading-500" style={{ marginLeft: '30px' }}>
          <one-ux-text className="dashboard-heading">Stratsys AI Dashboards</one-ux-text>
        </div>
      </div>

      <div className="full-container">
        {displayG === false && (
          <div className="spinner">
            <div class="typing-indicator2">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}

        {displayG === true &&
          graphs.map((graph, index) => (
            <Graph
              key={index}
              graphData={graph.graphData}
              graphConf={graph.graphConf}
              setGraphData={(data) => updateGraphData(index, data)}
              setGraphConf={(conf) => updateGraphConf(index, conf)}
              onEdit={() => {
                console.log('Edit', graph)
                editGraph(graph)
              }}
              onDelete={() => removeGraph(graph.id)}
            />
          ))}
      </div>
    </div>
  )
}

export default DashboardPage
